globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.History = appCustomerSpace.Modals.History || {};

appCustomerSpace.Modals.History.DopamineRegister = (function(superClass) {

  utils.extend(DopamineRegister, superClass);

  function DopamineRegister() {
    return DopamineRegister.__super__.constructor.apply(this, arguments);
  }

  $.extend(DopamineRegister.prototype, {
    init: function() {
      var modal = this;

      modal.$html.find('input[type=checkbox]').on('change', function(){
        modal._displayRefreshRange(modal._shouldRefreshSignals());
      });

      return DopamineRegister.__super__.init.apply(this, arguments);
    },
    _shouldRefreshSignals: function(){
      return this.$html.find('input[name=refresh_realtime_signals]').is(':checked') || this.$html.find('input[name=refresh_monthly_signals]').is(':checked');
    },
    _displayRefreshRange: function(bool){
      var $datesRange = this.$html.find('.dates-range');

      if(bool) {
        $datesRange.find('input').prop('disabled', false);
        $datesRange.show();
        $datesRange.find('input[name=refresh_from]').focus();
      } else {
        $datesRange.find('input').prop('disabled', true);
        $datesRange.hide()
      }
    },
    callbackSuccess: function(data, successMsg) {
      if(this._shouldRefreshSignals()) {
        window.location.reload()
      } else {
        DopamineRegister.__super__.callbackSuccess.apply(this, arguments);
      }
    }
  });

  return DopamineRegister;

})(appCustomerSpace.Modal);
